import { IReminder } from '@alberta/konexi-shared';
import { Injectable } from '@angular/core';
import { ReminderComponentModel } from 'src/app/business/reminder/reminder-component-model';
import { ReminderViewModel } from 'src/app/business/reminder/reminder-view-model';
import { map } from 'src/app/common/mapper/mapper';
import { observe } from 'src/app/common/tracking';
import { ReminderDto } from 'src/app/shared/models/reminder/reminder-dto.model';
import { ActionEvent, TrackerService } from 'src/app/shared/services/tracker.service';

@Injectable()
export class ReminderEditService {
  constructor(
    private readonly _reminderComponentModel: ReminderComponentModel,
    private readonly _trackingService: TrackerService
  ) {}

  public async handle(hasReminder: boolean, source: IReminder, origin?: IReminder) {
    if (hasReminder && !origin) {
      return await this.create(source);
    } else if (!hasReminder && origin) {
      return await this.edit(origin, { archived: true } as IReminder);
    } else if (hasReminder && origin) {
      return await this.edit(origin, source);
    }
  }

  private async edit(origin: IReminder, source: IReminder): Promise<IReminder> {
    const reminderViewModel: ReminderViewModel = observe(Object.assign(new ReminderViewModel(), origin));
    Object.assign(reminderViewModel, source);
    if (!source.archived) {
      reminderViewModel.hasBeenSeen = false;
    }

    await this._reminderComponentModel.edit(reminderViewModel, map(reminderViewModel, new ReminderDto()));

    this._trackingService.trackReminderEdited(ActionEvent.Done, reminderViewModel._id);

    return reminderViewModel;
  }

  private async create(source: IReminder): Promise<IReminder> {
    const reminderViewModel = Object.assign(new ReminderViewModel(), source);

    await this._reminderComponentModel.create(map(reminderViewModel, new ReminderDto()));

    this._trackingService.trackReminderCreated(ActionEvent.Done, reminderViewModel._id);

    return reminderViewModel;
  }
}
